import axios from 'axios';

// Navigation callback for handling auth redirects
let navigateToLogin: (() => void) | null = null;

// Function to set the navigation callback
export const setNavigationCallback = (callback: () => void) => {
  navigateToLogin = callback;
};

// Create a configured axios instance
const api = axios.create({
  baseURL: process.env.NODE_ENV === 'production' 
    ? '/api' 
    : (process.env.REACT_APP_API_URL || 'http://localhost:5000/api'),
  // Default for normal JSON calls. File uploads/downloads override this
  // per-request (timeout: 300000) since large files can take far longer.
  timeout: 20000,
});

// Add request interceptor to include auth token if available
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid
      localStorage.removeItem('token');
      // Don't redirect for public endpoints
      if (!error.config.url?.includes('/messages') && !error.config.url?.includes('/subjects')) {
        if (navigateToLogin) {
          // Use React Router navigation instead of hard redirect
          navigateToLogin();
        } else {
          // Fallback to hard redirect if navigation callback is not set
          console.warn('Navigation callback not set, using fallback redirect');
          window.location.href = '/login';
        }
      }
    }
    return Promise.reject(error);
  }
);

export default api;